define('uikit/views/table.selected',['require','exports','module','marionette','../mixins/component.mixin'],function(require, exports, module){
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');

  var TableSelectedView = Mn.ItemView.extend(ComponentMixin).extend({

    options: {
      visible : false,
      inverted: false
    },

    forceUpdate: { visible: true },

    template: function() { return '<ui name="view" />'; },

    _show: function() {
      this.view.$el.css('background-color', this._defaultColor);
    },

    _hide: function() {
      this.view.$el.css('background-color', 'transparent');
    },

    getRow: function() {
      return this.getOption('rowView');
    },

    getTable: function() {
      return this.getRow().tableView;
    },

    onChangeInverted: function() {
      if (this.view) {
        this.view.inverted = this.inverted;
      }
    },

    onFirstRender: function() {
      var row     = this.getOption('rowView'),
          table   = row.tableView,
          entered = false;

      row
          .on('mouseenter', function() {
            entered = true;

            this.visible = true;
          }, this)
          .on('mouseleave', function() {
            entered = false;
            if (!row.active) {
              this.visible = false;
            }
          }, this)
          .on('change:active', function() {
            if (!row.active && !entered) {
              this.visible = false;
            } else if (row.active && table.selection) {
              this.visible = true;
            }
          }, this)
          .listenTo(table, 'change:selection', function() {
            if (!table.selection) {
              this.visible = false;
            } else if (entered) {
              this.visible = true;
            }
          })

      if (row.active) {
        this.visible = true;
      }

      this._defaultColor = this.view.$el.css('background-color');
    }

  });

  module.exports = TableSelectedView;
});
